module.exports = __webpack_public_path__ + "resources/img/img-glassdome.a8df288027d673f8d6ed730304c5f7dd.png";